// extracted by mini-css-extract-plugin
module.exports = {"noDataCard":"UserSubscriptionsPageView_noDataCard__rP738","addButton":"UserSubscriptionsPageView_addButton__3M6DF"};